<template>
  <form
    class="pdp-purchase-form"
    :class="{ 'is-flashing': isFlashing }"
    @submit.prevent="submit"
  >
    <div v-if="!canShowButtonLink">
      <PurchaseOptions v-if="showPurchaseOptions" />
      <OneTimePurchaseLabel v-else />
    </div>
    <footer v-if="isOutOfStock && !canShowButtonLink">
      <p class="pdp-purchase-form-error-message">
        <a
          id="BIS_trigger"
          href="#"
          class="button pdp-purchase-form-out-of-stock-button"
        >
          {{ translations.outOfStock }}
        </a>
      </p>
    </footer>
    <footer v-else>
      <QuantitySelectorDropdown
        v-if="quantitySelector.type === 'dropdown'"
        :quantity="quantity"
        :multiplier="quantitySelector.multiplier"
        :singular-text-raw="quantitySelector.textSingularRaw"
        :plural-text-raw="quantitySelector.textPluralRaw"
        :inventory-quantity="inventoryQuantity"
        @change="setQuantity"
      />
      <QuantitySelectorIncremental
        v-if="quantitySelector.type === 'incremental' && !canShowButtonLink"
        :quantity="quantity"
        :multiplier="quantitySelector.multiplier"
        :inventory-quantity="inventoryQuantity"
        @change="setQuantity"
      />
      <ButtonLink
        v-if="canShowButtonLink"
        :href="linkTo"
        :text="translations.addToCart"
      />

      <PurchaseButton
        v-else
        :class="{ 'button-disabled': hasNotEnoughStock }"
      />
    </footer>
    <p v-if="hasNotEnoughStock" class="pdp-purchase-form-error-message">
      {{ translations.notEnoughStock }}
    </p>
  </form>
</template>

<script>
import ButtonLink from './ButtonLink.vue';
import OneTimePurchaseLabel from './OneTimePurchaseLabel.vue';
import PurchaseButton from './PurchaseButton.vue';
import PurchaseOptions from './PurchaseOptions.vue';
import QuantitySelectorDropdown from './QuantitySelectorDropdown.vue';
import QuantitySelectorIncremental from './QuantitySelectorIncremental.vue';

import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import { purchaseForm, mutations, actions } from './store';

export default {
  components: {
    PurchaseOptions,
    QuantitySelectorDropdown,
    QuantitySelectorIncremental,
    PurchaseButton,
    OneTimePurchaseLabel,
    ButtonLink
  },

  data() {
    return {
      isFlashing: false
    };
  },

  computed: {
    canShowButtonLink: function() {
      if (__SHOPIFY_ENV__ === 'myflavia') {
        if (this.linkTo) {
          return this.linkTo.length !== 0 ? true : false;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    ...mapState(purchaseForm, [
      'hasNotEnoughStock',
      'quantity',
      'quantitySelector',
      'selectedProductType',
      'showPurchaseOptions',
      'translations',
      'oneTime',
      'linkTo'
    ]),

    ...mapGetters(purchaseForm, ['inventoryQuantity', 'isOutOfStock'])
  },

  watch: {
    quantity(newVal, oldVal) {
      if (newVal < oldVal) {
        this.setHasNotEnoughStock(false);
      }
    },

    selectedVariant() {
      this.setHasNotEnoughStock(false);
    },

    inventoryQuantity(newVal) {
      if (newVal < this.quantity) {
        this.setQuantity(newVal || 1);
      }
    }
  },

  mounted() {
    this.$globalEventBus.addListener(
      'flyoutCart.removeItem',
      this.clearNotEnoughStockOnRemoveFromCart
    );

    this.$globalEventBus.addListener(
      'flyoutCart.updatedState',
      flyoutCartState => {
        if (flyoutCartState.freeGift) {
          this.setShouldShowFreeGiftDropdown(false);
        } else if (!flyoutCartState.freeGift) {
          this.setShouldShowFreeGiftDropdown(true);
        }
      }
    );
  },

  methods: {
    ...mapMutations({
      setQuantity: `${purchaseForm}/${mutations.SET_QUANTITY}`,
      setShouldShowFreeGiftDropdown: `${purchaseForm}/${mutations.SET_SHOULD_SHOW_FREE_GIFT_DROPDOWN}`,
      setHasNotEnoughStock: `${purchaseForm}/${mutations.SET_HAS_NOT_ENOUGH_STOCK}`
    }),

    ...mapActions({
      addToCart: `${purchaseForm}/${actions.addToCart}`
    }),

    flashOptions() {
      if (this.isFlashing) {
        return false;
      }

      this.isFlashing = true;

      this.$nextTick().then(() => {
        window.setTimeout(() => {
          this.isFlashing = false;
        }, 600);
      });
    },

    submit() {
      if (!this.selectedProductType) {
        this.flashOptions();

        return false;
      }

      this.addToCart();
    },

    clearNotEnoughStockOnRemoveFromCart(item) {
      if (this.selectedVariant && this.selectedVariant.id === item.id) {
        this.setHasNotEnoughStock(false);
      } else if (this.oneTime.id === item.id) {
        this.setHasNotEnoughStock(false);
      }
    }
  }
};
</script>
